export default __webpack_public_path__ + "static/media/printing_queue_error.7d179b63.png";